import { NextParsedUrlQuery } from "next/dist/server/request-meta";
import { Variant } from "../../../types/types";
import { encodeSize } from "../../../utils/string/encodeSize";
import type { UrlObject } from "url";

export function createSelectedSizeUrlObj(
  selectedSize: string,
  query: NextParsedUrlQuery,
  currentVariant: Variant,
): UrlObject {
  const queryParams = Object.entries(query).reduce((acc, [key, val]) => {
    return key === "path" || !val ? acc : { ...acc, [key]: val };
  }, {});

  return {
    pathname: currentVariant.canonicalURL,
    query: { ...queryParams, size: encodeSize(selectedSize) },
  };
}
